import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { STANDARD_PACKAGING } from '../types/standard-packaging.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for StandardPackaging (0160) — org reusable packaging templates.
 * Stored in 'org/{orgId}/standard-packaging'.
 */
export const standardPackagingDescriptor = {
    name: STANDARD_PACKAGING,
    label: 'Embalagem padrão',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/standard-packaging',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Reusable packaging template (code, quantity, unit) for ProductUnit prefill',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
        },
        {
            name: 'code',
            example: 20,
            label: 'Código',
            type: 'number',
            required: true,
            unique: true,
            autoNumber: true,
            description: 'Numeric packaging-template code (master-data identifier; non-negative, capped at MAX_CODE_SMALL)',
        },
        {
            name: 'description',
            example: 'Rolo 20 kg',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
        },
        {
            name: 'unitCode',
            example: 'KG',
            label: 'Unidade',
            type: 'string',
            required: false,
            maxLength: FIELD_LIMITS.UNIT,
            description: 'Commercial unit code (e.g. CX, RL)',
        },
        {
            name: 'defaultQuantity',
            example: 20,
            label: 'Quantidade padrão',
            type: 'number',
            required: true,
            description: 'Base units per packaging (> 0). Prefills ProductUnit.factor',
        },
        {
            name: 'notes',
            example: 'Rolo padrão de malha tingida',
            label: 'Observações',
            type: 'string',
            required: false,
            maxLength: FIELD_LIMITS.NOTES,
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [...AUDIT_FOREIGN_KEYS],
};
//# sourceMappingURL=standard-packaging.descriptor.js.map